import { differenceInMilliseconds } from 'date-fns';
import { ceil } from 'lodash';

export const calculateProgress = (startDate: string, endDate: string) => {
  const currentDate = new Date();
  const formattedStartDate = new Date(startDate);
  const formattedEndDate = new Date(endDate);

  const totalDuration = differenceInMilliseconds(formattedEndDate, formattedStartDate);
  const elapsedDuration = differenceInMilliseconds(currentDate, formattedStartDate);
  const progress = (elapsedDuration / totalDuration) * 100;
  return progress > 100 ? 100 : ceil(progress);
};
